import Vue from 'vue'
import App from './App'
import router from './router'

// import wx from './jweixin160.js'
// import jWeixin from './jweixin160.js'


// 全局less
import './common/public.less'
// api
import api from './request/api.js'
// axios
import axios from './request/https.js'
import VueAxios from 'vue-axios'
// vant
import 'vant/lib/index.css';
import {
  Toast,
  Swipe,
  SwipeItem,
  Lazyload,
  Col,
  Row,
  Collapse,
  CollapseItem,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Rate,
  Picker,
  Overlay,
  Tab,
  Tabs,
  RadioGroup,
  Radio,
  DropdownMenu,
  DropdownItem,
  Uploader,
  List,
  Popover,
  Popup,
  Divider,
  Sticky
} from 'vant';
Vue.use(VueAxios, axios)
Vue.use(Toast)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload)
Vue.use(Col);
Vue.use(Row);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(DatetimePicker);
Vue.use(Rate);
Vue.use(Picker);
Vue.use(Overlay);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Uploader);
Vue.use(List);
Vue.use(Popover);
Vue.use(Popup);
Vue.use(Divider);
Vue.use(Sticky);
// loading
import './common/loading/loading.css';
import Loading from './common/loading/loading';
Vue.use(Loading);
// cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// swiper
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(vueSwiper)
// qs
import qs from 'qs';
Vue.prototype.$axios = axios
axios.defaults.baseURL = ''
// animated
import animated from 'animate.css'
Vue.use(animated)
// v-touch
import VueTouch from 'vue-touch';
Vue.use(VueTouch, {name: 'v-touch'});
VueTouch.config.swipe = {
  threshold: 10 //手指左右滑动触发事件距离
}
// 粘贴板
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;
// 防止重复加载
import preventReClick from './lib/preventReClick.js' //防多次点击，重复提交

Vue.prototype.api = api
Vue.config.productionTip = false

// 引入VueX
import store from './store/index.js';


Vue.config.ignoredElements = ['wx-open-launch-weapp'];

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js